import { Component, ElementRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ExcelService } from '@services/excel.service';
import { BehaviorSubject } from 'rxjs';
import { DeviceInfoService } from 'src/app/services/device-info.service';
import { ExcelObject, UtilService } from 'src/app/services/util.service';
import { utils, writeFile } from 'xlsx';

@Component({
	selector: 'app-excel-button',
	templateUrl: './excel-button.component.html',
	styleUrls: ['./excel-button.component.scss'],
})
export class ExcelButtonComponent {
	// @Input() onlyEmit?: string;
	@Input() filename?: string;
	@Input() hideText?: boolean;
	@Input() tableQuerySelector?: string;

	@Output() readonly clicked = new EventEmitter<void>();

	private _excel = inject(ExcelService);

	constructor(public _device: DeviceInfoService) {}

	handleWhichFunctionToUse() {
		this.clicked.emit();
		if (this.clicked.observed) {
			return;
		}

		this.downloadExcel();
	}

	downloadExcel() {
		this._excel.downloadSimpleExcel({ tableQuerySelector: this.tableQuerySelector, filename: this.filename });
	}
}
